module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woods@2x_ce548f.jpg";